// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "item-xQ8s6";
var _3 = "item_active-3D41l";
var _4 = "item_recommend-1ynNf";
var _5 = "avatar-1Imzl";
var _6 = "passengerName-2I0oG";
var _7 = "payload-x7QHB";
var _8 = "select-3Zfg7";
var _9 = "money-B3_LY";
var _a = "mobilePassenger_container-w2yxy";
export { _1 as "__esModule", _2 as "item", _3 as "item_active", _4 as "item_recommend", _5 as "avatar", _6 as "passengerName", _7 as "payload", _8 as "select", _9 as "money", _a as "mobilePassenger_container" }
export default { "__esModule": _1, "item": _2, "item_active": _3, "item_recommend": _4, "avatar": _5, "passengerName": _6, "payload": _7, "select": _8, "money": _9, "mobilePassenger_container": _a }
